<wm-workflow-test-as-client 
  #testAsClientModal
  [showTestAsClient]="false"
  [workflowId]="testWorkflowId"
  [versionId]="testVersionId"
  [clientId]="_context?.client?.id"
  (onTest)="testWorkflow()">
</wm-workflow-test-as-client>

<div class="container mt-4">

  <h1>Workflow Template Library</h1>

  <form class="form-row align-items-end mt-3 mb-3" (ngSubmit)="search()">
    <div class="col-md-4 mb-2">
      <label for="name">Workflow Name</label>
      <input
        id="name"
        class="form-control"
        [(ngModel)]="name"
        name="name"
        placeholder="Enter workflow name"
      >
    </div>
    <div class="col-md-4 mb-2">
      <label for="tags">Tags (comma separated)</label>
      <input
        id="tags"
        class="form-control"
        [(ngModel)]="tags"
        name="tags"
        placeholder="e.g. finance,automation"
      >
    </div>
    <div class="col-md-2 mb-2">
      <button type="submit" class="btn btn-primary btn-block btn-raised">Search</button>
    </div>
  </form>

  <app-loader *ngIf="isLoading"></app-loader>

  <div
    *ngIf="!isLoading && workflows.length === 0"
    class="text-muted"
  >
    <i>
      No workflows found.
    </i>
  </div>

  <!-- Table layout for desktop/laptop (md and up) -->
  <div class="d-none d-md-block" *ngIf="workflows.length > 0">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Tags</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let workflow of workflows">
          <td>{{ workflow.name }}</td>
          <td>{{ workflow.description }}</td>
          <td>
            <span *ngFor="let tag of workflow.tags" class="badge badge-info mr-1">{{ tag }}</span>
          </td>
          <td>
            <div 
              class="btn-group float-right" 
              ngbDropdown 
              placement="bottom-right"
            >
                <button
                  type="button"
                  class="btn btn-raised btn-primary"
                  (click)="setTestWorkflowId(workflow.id, workflow.workflowVersionId)"
                >
                  Test
                </button>
              <button class="btn btn-raised btn-primary dropdown-toggle-split" ngbDropdownToggle></button>
              <div class="dropdown-menu" ngbDropdownMenu>
                <a
                  ngbDropdownItem
                  [routerLink]="['/admin/workflow-builder/readonly', workflow.id, workflow.workflowVersionId]"
                  target="_blank"
                >
                  View Workflow
                </a>
                <button
                  ngbDropdownItem
                  [routerLink]="['/admin/jurisdiction', _context?.client?.id, 'workflows', 'import', workflow.id]"
                >
                  Import Workflow
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Card layout for mobile/tablet (sm and below) -->
  <div class="d-block d-md-none" *ngIf="workflows.length > 0">
    <div class="mb-4" *ngFor="let workflow of workflows">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">{{ workflow.name }}</h5>
          <p class="card-text">{{ workflow.description }}</p>
          <div>
            <span *ngFor="let tag of workflow.tags" class="badge badge-info mr-1">{{ tag }}</span>
          </div>
        </div>
        <div class="card-footer bg-transparent border-top-0 d-flex flex-column flex-sm-row">
          <a
            [href]="startTestApplicationURL"
            target="_blank"
          >
            <button
              class="btn btn-primary btn-raised btn-block btn-sm mb-2 mb-sm-0 mr-sm-2"
              (click)="setTestWorkflowId(workflow.id)"
            >
              Test Workflow
            </button>
          </a>
          <button
            class="btn btn-primary btn-raised btn-block btn-sm mb-2 mb-sm-0 mr-sm-2"
            (click)="alertCannotOpenBuilder()"
          >
            View Workflow
          </button>
          <button
            class="btn btn-primary btn-raised btn-block btn-sm mb-2 mb-sm-0 mr-sm-2"
            [routerLink]="['/admin/jurisdiction',_context?.client?.id,'workflows','template-library','import',workflow.id]"
          >
            Import Workflow
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
